
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/socios",
      function () {
        return require("private-next-pages/socios/index.js");
      }
    ]);
  